// This file is auto-generated by @hey-api/openapi-ts

import type {
  ApiError,
  GetHostedBusinessData,
  GetHostedBusinessesData,
  GetHostedBusinessesResponses,
  GetHostedBusinessOwnersData,
  GetHostedBusinessOwnersResponses,
  GetHostedBusinessResponses,
  GetHostedCheckSessionData,
  GetHostedCheckSessionResponses,
  GetHostedIdentifySessionRequirementsData,
  GetHostedIdentifySessionRequirementsResponses,
  GetHostedOnboardingConfigData,
  GetHostedOnboardingConfigResponses,
  GetHostedOnboardingNidData,
  GetHostedOnboardingNidResponses,
  GetHostedOnboardingPrefillData,
  GetHostedOnboardingPrefillResponses,
  GetHostedOnboardingPrivacyPassData,
  GetHostedOnboardingStatusData,
  GetHostedOnboardingStatusResponses,
  GetHostedUserAuthMethodsData,
  GetHostedUserAuthMethodsResponses,
  GetHostedUserAuthorizedOrgsData,
  GetHostedUserAuthorizedOrgsResponses,
  GetHostedUserPrivateTokenData,
  GetHostedUserTokenData,
  GetHostedUserTokenResponses,
  GetOrgSdkArgsData,
  GetOrgSdkArgsResponses,
  HostedOnboardingD2pGenerateData,
  HostedOnboardingD2pGenerateResponses,
  HostedOnboardingD2pSmsData,
  HostedOnboardingD2pSmsResponses,
  HostedOnboardingD2pStatusData,
  HostedOnboardingD2pStatusPostData,
  HostedOnboardingD2pStatusPostResponses,
  HostedOnboardingD2pStatusResponses,
  PatchHostedBusinessOwnersData,
  PatchHostedBusinessOwnersResponses,
  PatchHostedBusinessVaultData,
  PatchHostedBusinessVaultResponses,
  PatchHostedIdentifySessionVaultData,
  PatchHostedIdentifySessionVaultResponses,
  PatchHostedUserVaultData,
  PatchHostedUserVaultResponses,
  PostHostedBusinessOnboardingData,
  PostHostedBusinessOnboardingResponses,
  PostHostedBusinessVaultDecryptData,
  PostHostedBusinessVaultDecryptResponses,
  PostHostedBusinessVaultValidateData,
  PostHostedBusinessVaultValidateResponses,
  PostHostedDocumentsByIdProcessData,
  PostHostedDocumentsByIdProcessResponses,
  PostHostedDocumentsByIdUploadBySideData,
  PostHostedDocumentsByIdUploadBySideResponses,
  PostHostedDocumentsData,
  PostHostedDocumentsResponses,
  PostHostedIdentifySessionChallengeData,
  PostHostedIdentifySessionChallengeResponses,
  PostHostedIdentifySessionChallengeVerifyData,
  PostHostedIdentifySessionChallengeVerifyResponses,
  PostHostedIdentifySessionData,
  PostHostedIdentifySessionKbaData,
  PostHostedIdentifySessionKbaResponses,
  PostHostedIdentifySessionResponses,
  PostHostedIdentifySessionVerifyData,
  PostHostedIdentifySessionVerifyResponses,
  PostHostedIdentifyValidationTokenData,
  PostHostedIdentifyValidationTokenResponses,
  PostHostedOnboardingAuthorizeData,
  PostHostedOnboardingAuthorizeResponses,
  PostHostedOnboardingAvisResultData,
  PostHostedOnboardingAvisResultResponses,
  PostHostedOnboardingBackData,
  PostHostedOnboardingBackResponses,
  PostHostedOnboardingChallengeData,
  PostHostedOnboardingChallengeResponses,
  PostHostedOnboardingChallengeVerifyData,
  PostHostedOnboardingChallengeVerifyResponses,
  PostHostedOnboardingData,
  PostHostedOnboardingFpData,
  PostHostedOnboardingFpResponses,
  PostHostedOnboardingPrefillChallengeData,
  PostHostedOnboardingPrefillChallengeResponses,
  PostHostedOnboardingPrefillData,
  PostHostedOnboardingPrefillResponses,
  PostHostedOnboardingPrefillVerifiedCommitData,
  PostHostedOnboardingPrefillVerifiedCommitResponses,
  PostHostedOnboardingPrefillVerifiedData,
  PostHostedOnboardingPrefillVerifiedResponses,
  PostHostedOnboardingProceedData,
  PostHostedOnboardingProceedResponses,
  PostHostedOnboardingProcessData,
  PostHostedOnboardingProcessResponses,
  PostHostedOnboardingResponses,
  PostHostedOnboardingSdsData,
  PostHostedOnboardingSdsResponses,
  PostHostedOnboardingSilentData,
  PostHostedOnboardingSilentResponses,
  PostHostedOnboardingSkipPasskeyRegisterData,
  PostHostedOnboardingSkipPasskeyRegisterResponses,
  PostHostedOnboardingTelData,
  PostHostedOnboardingTelResponses,
  PostHostedOnboardingTimelineData,
  PostHostedOnboardingTimelineResponses,
  PostHostedOnboardingValidateData,
  PostHostedOnboardingValidateResponses,
  PostHostedSdkVersionData,
  PostHostedSdkVersionResponses,
  PostHostedUserAttestDeviceChallengeData,
  PostHostedUserAttestDeviceChallengeResponses,
  PostHostedUserAttestDeviceData,
  PostHostedUserAttestDeviceResponses,
  PostHostedUserChallengeData,
  PostHostedUserChallengeResponses,
  PostHostedUserChallengeVerifyData,
  PostHostedUserChallengeVerifyResponses,
  PostHostedUserConsentData,
  PostHostedUserConsentResponses,
  PostHostedUserDocumentsByIdProcessData,
  PostHostedUserDocumentsByIdProcessResponses,
  PostHostedUserDocumentsByIdUploadBySideData,
  PostHostedUserDocumentsByIdUploadBySideResponses,
  PostHostedUserDocumentsData,
  PostHostedUserDocumentsResponses,
  PostHostedUserEmailVerifyData,
  PostHostedUserEmailVerifyResponses,
  PostHostedUserExpireSessionData,
  PostHostedUserExpireSessionResponses,
  PostHostedUserTokensData,
  PostHostedUserTokensResponses,
  PostHostedUserUploadByDocumentIdentifierData,
  PostHostedUserUploadByDocumentIdentifierResponses,
  PostHostedUserVaultDecryptData,
  PostHostedUserVaultDecryptResponses,
  PostHostedUserVaultValidateData,
  PostHostedUserVaultValidateResponses,
  PostOrgSdkArgsData,
  PostOrgSdkArgsResponses,
  PostOrgSdkTelemetryData,
  PostOrgSdkTelemetryResponses,
} from '@onefootprint/request-types';
import { type Client, type Options as ClientOptions, formDataBodySerializer, type TDataShape } from './client';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Get information about the business for which we started a KYC of a beneficial owner
 */
export const getHostedBusiness = <ThrowOnError extends boolean = true>(
  options?: Options<GetHostedBusinessData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetHostedBusinessResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Kyb-Bo-Token',
        type: 'apiKey',
      },
    ],
    url: '/hosted/business',
    ...options,
  });
};

/**
 * Gets or creates the business Onboarding, optionally accepting an existing business. You can select an existing business from the results of `GET /hosted/businesses`.
 */
export const postHostedBusinessOnboarding = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedBusinessOnboardingData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedBusinessOnboardingResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/business/onboarding',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get information about the beneficial owners of this business
 */
export const getHostedBusinessOwners = <ThrowOnError extends boolean = true>(
  options?: Options<GetHostedBusinessOwnersData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetHostedBusinessOwnersResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/business/owners',
    ...options,
  });
};

/**
 * Applies multiple operations in batch to update or create business owners. NOTE: the open API documentation for the request is extremely incorrect for this API.
 */
export const patchHostedBusinessOwners = <ThrowOnError extends boolean = true>(
  options: Options<PatchHostedBusinessOwnersData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchHostedBusinessOwnersResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/business/owners',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Updates data in a business vault. Can be used to update `business.` data
 */
export const patchHostedBusinessVault = <ThrowOnError extends boolean = true>(
  options: Options<PatchHostedBusinessVaultData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchHostedBusinessVaultResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/business/vault',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Decrypts the specified list of fields from the provided vault.
 */
export const postHostedBusinessVaultDecrypt = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedBusinessVaultDecryptData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedBusinessVaultDecryptResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/business/vault/decrypt',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Checks if provided vault data is valid before adding it to the business vault
 */
export const postHostedBusinessVaultValidate = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedBusinessVaultValidateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedBusinessVaultValidateResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/business/vault/validate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get information about the businesses owned by the authenticated user
 */
export const getHostedBusinesses = <ThrowOnError extends boolean = true>(
  options?: Options<GetHostedBusinessesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetHostedBusinessesResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/businesses',
    ...options,
  });
};

/**
 * Checks a hosted session token for expiration/validity
 */
export const getHostedCheckSession = <ThrowOnError extends boolean = true>(
  options?: Options<GetHostedCheckSessionData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetHostedCheckSessionResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/check_session',
    ...options,
  });
};

/**
 * Create a new document for the outstanding document request
 */
export const postHostedDocuments = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedDocumentsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedDocumentsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/documents',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Process the document and run any vendor verifications.
 */
export const postHostedDocumentsByIdProcess = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedDocumentsByIdProcessData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedDocumentsByIdProcessResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/documents/{id}/process',
    ...options,
  });
};

/**
 * Upload an image for the given side to the provided document.
 */
export const postHostedDocumentsByIdUploadBySide = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedDocumentsByIdUploadBySideData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedDocumentsByIdUploadBySideResponses, ApiError, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/documents/{id}/upload/{side}',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * Creates an identify session token.
 */
export const postHostedIdentifySession = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedIdentifySessionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedIdentifySessionResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Onboarding-Config-Key',
        type: 'apiKey',
      },
      {
        name: 'X-Kyb-Bo-Token',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/identify/session',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Sends a challenge to the phone number or email saved in this identify session and returns an HTTP 200
 */
export const postHostedIdentifySessionChallenge = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedIdentifySessionChallengeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedIdentifySessionChallengeResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/identify/session/challenge',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Verifies the response to a challenge
 */
export const postHostedIdentifySessionChallengeVerify = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedIdentifySessionChallengeVerifyData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostHostedIdentifySessionChallengeVerifyResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/identify/session/challenge/verify',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Respond to a KBA challenge to prove knowledge of existing data in the vault.
 */
export const postHostedIdentifySessionKba = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedIdentifySessionKbaData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedIdentifySessionKbaResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/identify/session/kba',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Returns the list of requirements for an identify session.
 */
export const getHostedIdentifySessionRequirements = <ThrowOnError extends boolean = true>(
  options?: Options<GetHostedIdentifySessionRequirementsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetHostedIdentifySessionRequirementsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/identify/session/requirements',
    ...options,
  });
};

/**
 * Updates the data stored in this identify session.
 */
export const patchHostedIdentifySessionVault = <ThrowOnError extends boolean = true>(
  options: Options<PatchHostedIdentifySessionVaultData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchHostedIdentifySessionVaultResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/identify/session/vault',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Verifies that all identify requirements have been met.
 */
export const postHostedIdentifySessionVerify = <ThrowOnError extends boolean = true>(
  options?: Options<PostHostedIdentifySessionVerifyData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<PostHostedIdentifySessionVerifyResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/identify/session/verify',
    ...options,
  });
};

/**
 * Generate a validation token after the user finishes the identify flow.
 */
export const postHostedIdentifyValidationToken = <ThrowOnError extends boolean = true>(
  options?: Options<PostHostedIdentifyValidationTokenData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<PostHostedIdentifyValidationTokenResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/identify/validation_token',
    ...options,
  });
};

/**
 * Gets or creates the Onboarding for this (user, ob_config) pair.
 */
export const postHostedOnboarding = <ThrowOnError extends boolean = true>(
  options?: Options<PostHostedOnboardingData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<PostHostedOnboardingResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Mark the onboarding as authorized and initiate IDV checks
 */
export const postHostedOnboardingAuthorize = <ThrowOnError extends boolean = true>(
  options?: Options<PostHostedOnboardingAuthorizeData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<PostHostedOnboardingAuthorizeResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/authorize',
    ...options,
  });
};

/**
 * Returns the workflow's status. Only available for demo tenants and POS tenants.
 */
export const postHostedOnboardingAvisResult = <ThrowOnError extends boolean = true>(
  options?: Options<PostHostedOnboardingAvisResultData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<PostHostedOnboardingAvisResultResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/avis_result',
    ...options,
  });
};

/**
 * Backs up the graphical workflow to the previous node.
 */
export const postHostedOnboardingBack = <ThrowOnError extends boolean = true>(
  options?: Options<PostHostedOnboardingBackData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<PostHostedOnboardingBackResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/back',
    ...options,
  });
};

/**
 * Sends an OTP challenge to the phone number or email in this onboarding's vault and returns an HTTP 200. Errors sending the challenge are surfaced on the `error` field of the response.
 */
export const postHostedOnboardingChallenge = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedOnboardingChallengeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedOnboardingChallengeResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/challenge',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Verifies the response to a challenge sent via POST /hosted/onboarding/challenge, recording an auth event for this workflow and marking the contact info as verified.
 */
export const postHostedOnboardingChallengeVerify = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedOnboardingChallengeVerifyData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedOnboardingChallengeVerifyResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/challenge/verify',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get the details of the current onboarding session, either via public key or via a user auth token.
 */
export const getHostedOnboardingConfig = <ThrowOnError extends boolean = true>(
  options?: Options<GetHostedOnboardingConfigData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetHostedOnboardingConfigResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Onboarding-Config-Key',
        type: 'apiKey',
      },
      {
        name: 'X-Kyb-Bo-Token',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/config',
    ...options,
  });
};

/**
 * Generates a new d2p session token for the currently authenticated user. The d2p session token has a limited scope, and also includes some status metadata for syncing state across the phone and desktop.
 */
export const hostedOnboardingD2pGenerate = <ThrowOnError extends boolean = true>(
  options: Options<HostedOnboardingD2pGenerateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<HostedOnboardingD2pGenerateResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/d2p/generate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Send an SMS with a link to the phone onboarding page.
 */
export const hostedOnboardingD2pSms = <ThrowOnError extends boolean = true>(
  options: Options<HostedOnboardingD2pSmsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<HostedOnboardingD2pSmsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/d2p/sms',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Gets the status of the provided d2p session. Requires the d2p session token as the auth header.
 */
export const hostedOnboardingD2pStatus = <ThrowOnError extends boolean = true>(
  options?: Options<HostedOnboardingD2pStatusData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<HostedOnboardingD2pStatusResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/d2p/status',
    ...options,
  });
};

/**
 * Update the status of the provided d2p session. Only allows updating to certain statuses.
 */
export const hostedOnboardingD2pStatusPost = <ThrowOnError extends boolean = true>(
  options: Options<HostedOnboardingD2pStatusPostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<HostedOnboardingD2pStatusPostResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/d2p/status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Records a fingerprint visitorID for the Fingerprint SDK in the frontend
 */
export const postHostedOnboardingFp = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedOnboardingFpData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedOnboardingFpResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/fp',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Retrieve identifier used for NeuroId
 */
export const getHostedOnboardingNid = <ThrowOnError extends boolean = true>(
  options?: Options<GetHostedOnboardingNidData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetHostedOnboardingNidResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/nid',
    ...options,
  });
};

/**
 * Get context on whether we can prefill data from an external match into this onboarding session.
 */
export const getHostedOnboardingPrefill = <ThrowOnError extends boolean = true>(
  options?: Options<GetHostedOnboardingPrefillData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetHostedOnboardingPrefillResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/prefill',
    ...options,
  });
};

/**
 * Prefill data from the matching external vault into this vault.
 */
export const postHostedOnboardingPrefill = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedOnboardingPrefillData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedOnboardingPrefillResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/prefill',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Initiate a challenge to prefill data from an external match into this onboarding session.
 */
export const postHostedOnboardingPrefillChallenge = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedOnboardingPrefillChallengeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedOnboardingPrefillChallengeResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/prefill/challenge',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Prefill data from Verified into this vault.
 */
export const postHostedOnboardingPrefillVerified = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedOnboardingPrefillVerifiedData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedOnboardingPrefillVerifiedResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/prefill_verified',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Commit a prefill result and write its data to the vault.
 */
export const postHostedOnboardingPrefillVerifiedCommit = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedOnboardingPrefillVerifiedCommitData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostHostedOnboardingPrefillVerifiedCommitResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/prefill_verified/commit',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * initiates privacy pass protocol.
 */
export const getHostedOnboardingPrivacyPass = <ThrowOnError extends boolean = true>(
  options?: Options<GetHostedOnboardingPrivacyPassData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<unknown, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/privacy_pass',
    ...options,
  });
};

/**
 * Advances the graphical workflow if possible. Returns the next set of outstanding onboarding requirements.
 */
export const postHostedOnboardingProceed = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedOnboardingProceedData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedOnboardingProceedResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/proceed',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Continue processing the onboarding after user this stage of user input has finished. Deprecated in favor of `POST /hosted/onboarding/proceed`
 */
export const postHostedOnboardingProcess = <ThrowOnError extends boolean = true>(
  options?: Options<PostHostedOnboardingProcessData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<PostHostedOnboardingProcessResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/process',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Records a deviceSessionId from the Socure Device SDK in the frontend
 */
export const postHostedOnboardingSds = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedOnboardingSdsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedOnboardingSdsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/sds',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Runs through the identify flow and onboarding flow for a user.
 */
export const postHostedOnboardingSilent = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedOnboardingSilentData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedOnboardingSilentResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/silent',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Tells us that a passkey registration was skipped
 */
export const postHostedOnboardingSkipPasskeyRegister = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedOnboardingSkipPasskeyRegisterData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostHostedOnboardingSkipPasskeyRegisterResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/skip_passkey_register',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Returns the remaining onboarding requirements. Deprecated in favor of `POST /hosted/onboarding/proceed`
 */
export const getHostedOnboardingStatus = <ThrowOnError extends boolean = true>(
  options?: Options<GetHostedOnboardingStatusData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetHostedOnboardingStatusResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/status',
    ...options,
  });
};

/**
 * Performs a lookup with Stytch on the passed up telemetry_id and records the response + risk signals
 */
export const postHostedOnboardingTel = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedOnboardingTelData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedOnboardingTelResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/tel',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Log a timeline event for this user using a frontend-provided page identifier
 */
export const postHostedOnboardingTimeline = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedOnboardingTimelineData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedOnboardingTimelineResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/timeline',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Finish onboarding the user. Returns the validation token that can be exchanged for a permanent Footprint user token.
 */
export const postHostedOnboardingValidate = <ThrowOnError extends boolean = true>(
  options?: Options<PostHostedOnboardingValidateData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<PostHostedOnboardingValidateResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/onboarding/validate',
    ...options,
  });
};

/**
 * Record SDK version usage for a tenant.
 */
export const postHostedSdkVersion = <ThrowOnError extends boolean = true>(
  options?: Options<PostHostedSdkVersionData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<PostHostedSdkVersionResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Onboarding-Config-Key',
        type: 'apiKey',
      },
      {
        name: 'X-Kyb-Bo-Token',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/sdk_version',
    ...options,
  });
};

/**
 * receive the attestation
 * Parses and accepts a user's onboarding device attestation
 */
export const postHostedUserAttestDevice = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedUserAttestDeviceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedUserAttestDeviceResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/user/attest_device',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * initiate the attestation challenge
 * Generate a device attestation challenge
 */
export const postHostedUserAttestDeviceChallenge = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedUserAttestDeviceChallengeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedUserAttestDeviceChallengeResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/user/attest_device/challenge',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Returns information about the auth methods this user has registered.
 */
export const getHostedUserAuthMethods = <ThrowOnError extends boolean = true>(
  options?: Options<GetHostedUserAuthMethodsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetHostedUserAuthMethodsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/user/auth_methods',
    ...options,
  });
};

/**
 * Returns a list of organizations onto which the user has onboarded
 */
export const getHostedUserAuthorizedOrgs = <ThrowOnError extends boolean = true>(
  options?: Options<GetHostedUserAuthorizedOrgsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetHostedUserAuthorizedOrgsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/user/authorized_orgs',
    ...options,
  });
};

/**
 * Sends a challenge of the requested kind
 */
export const postHostedUserChallenge = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedUserChallengeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedUserChallengeResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/user/challenge',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Verify the previously sent challenge and attach the new form of contact info to the vault
 */
export const postHostedUserChallengeVerify = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedUserChallengeVerifyData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedUserChallengeVerifyResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/user/challenge/verify',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Records a user's consent to some terms.
 */
export const postHostedUserConsent = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedUserConsentData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedUserConsentResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/user/consent',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Create a new document for the outstanding document request
 */
export const postHostedUserDocuments = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedUserDocumentsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedUserDocumentsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/user/documents',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Process the document and run any vendor verifications.
 */
export const postHostedUserDocumentsByIdProcess = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedUserDocumentsByIdProcessData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedUserDocumentsByIdProcessResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/user/documents/{id}/process',
    ...options,
  });
};

/**
 * Upload an image for the given side to the provided document.
 */
export const postHostedUserDocumentsByIdUploadBySide = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedUserDocumentsByIdUploadBySideData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostHostedUserDocumentsByIdUploadBySideResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/user/documents/{id}/upload/{side}',
    ...options,
  });
};

/**
 * Used to asynchronously verify a user's email address. Requires the token sent to the users email.
 */
export const postHostedUserEmailVerify = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedUserEmailVerifyData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedUserEmailVerifyResponses, ApiError, ThrowOnError>({
    url: '/hosted/user/email/verify',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Expires the session defined by `x-fp-authorization`
 */
export const postHostedUserExpireSession = <ThrowOnError extends boolean = true>(
  options?: Options<PostHostedUserExpireSessionData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<PostHostedUserExpireSessionResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/user/expire_session',
    ...options,
  });
};

/**
 * Returns information about the auth token. Can only be used in sandbox mode for demo tenants.
 */
export const getHostedUserPrivateToken = <ThrowOnError extends boolean = true>(
  options?: Options<GetHostedUserPrivateTokenData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<unknown, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/user/private/token',
    ...options,
  });
};

/**
 * Returns information about a given auth token.
 */
export const getHostedUserToken = <ThrowOnError extends boolean = true>(
  options?: Options<GetHostedUserTokenData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetHostedUserTokenResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/user/token',
    ...options,
  });
};

/**
 * Create a new token with the requested scopes using the permissions granted by the existing token. Used to create a secondary token with more limited scope. The new token's expiry time is the same as the old token's
 */
export const postHostedUserTokens = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedUserTokensData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedUserTokensResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/user/tokens',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * POSTs a document to the vault
 */
export const postHostedUserUploadByDocumentIdentifier = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedUserUploadByDocumentIdentifierData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostHostedUserUploadByDocumentIdentifierResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/user/upload/{documentIdentifier}',
    ...options,
  });
};

/**
 * Updates data in a user vault
 */
export const patchHostedUserVault = <ThrowOnError extends boolean = true>(
  options: Options<PatchHostedUserVaultData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchHostedUserVaultResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/user/vault',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Decrypts the specified list of fields from the provided vault.
 */
export const postHostedUserVaultDecrypt = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedUserVaultDecryptData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedUserVaultDecryptResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/user/vault/decrypt',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Checks if provided vault data is valid before adding it to the vault
 */
export const postHostedUserVaultValidate = <ThrowOnError extends boolean = true>(
  options: Options<PostHostedUserVaultValidateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostHostedUserVaultValidateResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/hosted/user/vault/validate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Fetch information from an existing SDK args session.
 */
export const getOrgSdkArgs = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgSdkArgsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgSdkArgsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Sdk-Args-Token',
        type: 'apiKey',
      },
    ],
    url: '/org/sdk_args',
    ...options,
  });
};

/**
 * Create a new session containing args for the SDK.
 */
export const postOrgSdkArgs = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgSdkArgsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgSdkArgsResponses, ApiError, ThrowOnError>({
    url: '/org/sdk_args',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Log contents of the HTTP body.
 */
export const postOrgSdkTelemetry = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgSdkTelemetryData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgSdkTelemetryResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Onboarding-Config-Key',
        type: 'apiKey',
      },
      {
        name: 'X-Kyb-Bo-Token',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/sdk_telemetry',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};
